import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import './index.css'

// Build info from Vite env (set at build time)
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE || 'dev'
export const BUILD_COMMIT = import.meta.env.VITE_BUILD_COMMIT || 'local'
export const BUILD_COMMIT_SHORT = import.meta.env.VITE_BUILD_COMMIT_SHORT || 'local'
export const APP_VERSION = `${BUILD_DATE !== 'dev' ? BUILD_DATE.slice(0, 10) : 'dev'}-${BUILD_COMMIT_SHORT}`

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || ''

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT || 'development',
    release: APP_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
  })
}

// Log version info to console in non-production
if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
  console.log(`Dashboard version: ${APP_VERSION}`)
  console.log(`Build date: ${BUILD_DATE}`)
  console.log(`Commit: ${BUILD_COMMIT_SHORT}`)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
